import React from "react";
import Navbar from "../components/Navbar";
import Awards from "../components/Awards";
import Aside from "../components/Aside";
import Footer from "../components/Footer";

const AwardPage = () => {
  return (
    <>
      <Navbar />
      <Awards />
      <Aside />
      <Footer />
    </>
  );
};

export default AwardPage;
